import { Injectable } from '@angular/core';
import { ConfigService } from '@services/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleScriptLoaderService {

  constructor(private config: ConfigService){}

  private static googleMapPromise: Promise<typeof google.maps> | null = null;
  private static readonly CALLBACK_NAME = 'GooglePlaces_cb';

  public getGoogleMapPlaces() {
    return this.loadGoogleMapPlace();
  }

  private loadGoogleMapPlace(): Promise<typeof google.maps> {
    if (GoogleScriptLoaderService.googleMapPromise) return GoogleScriptLoaderService.googleMapPromise;
    const existingScript = document.getElementById('google-places-js-script');
    if (existingScript) return this.getLoadedGoogleMap();
    return this.setGoogleMapScript();
  }

  private getLoadedGoogleMap(): Promise<typeof google.maps> {
    return new Promise((resolve, reject) => {
      if ((window as any).google?.maps) return resolve((window as any).google.maps);
      (window as any)[GoogleScriptLoaderService.CALLBACK_NAME] = () => resolve((window as any).google.maps);
      const script = document.getElementById('google-places-js-script');
      if (script) script.onerror = reject;
    });
  }

  private setGoogleMapScript(): Promise<typeof google.maps> {
    GoogleScriptLoaderService.googleMapPromise = new Promise((resolve, reject) => {
      (window as any)[GoogleScriptLoaderService.CALLBACK_NAME] = () => resolve((window as any).google.maps);
      const script = document.createElement('script');
      script.id = 'google-places-js-script';
      script.src = this.getScriptSrc(GoogleScriptLoaderService.CALLBACK_NAME);
      script.async = true;
      script.defer = true;
      script.onerror = reject;
      document.body.appendChild(script);
    });
    return GoogleScriptLoaderService.googleMapPromise;
  }

  private getScriptSrc(callback: string): string {
    const query = new URLSearchParams({
      v: 'weekly',
      callback,
      // key: GoogleScriptLoaderService.API_KEY,
      key: this.config.getGoogleAPIKey(),
      libraries: 'places',
      language: 'en',
      loading: 'async' 
    }).toString();
    return `https://maps.googleapis.com/maps/api/js?${query}`;
  }
}
